<template>
    <div id="navbar-block" class="navbar-block" :class="{'dark-theme': this.darkMenu, 'light-theme': !this.darkMenu}" :style="{'background': menuColor}">
        <GuestBlock v-if="!isFetch && isGuest"/>

        <MobileNavbar v-if="isMobile && !isFetch && !isGuest"/>
        <template v-else-if="!isFetch && !isGuest">
            <LeftBlock/>
            <RightBlock class="ml-auto"/>
        </template>

        <TimelineNavbar v-if="isFetch" :menu-color="menuColor"/>
    </div>
</template>

<script>

import {mapState} from "vuex";
import '@/styles/navbar/navbar.scss';
import {GetAccountDefaults, GetAccountProperty} from "@/utils/local-storage";
import EventBus, {MAIN_WINDOW_CLICK, MAIN_WINDOW_RESIZE, NAVBAR_MOUNTED, THEME_CHANGE_LOGO_URL, THEME_CHANGE_MENU_COLOR} from "@/utils/event-bus";
import {FETCH_NAVBAR} from "@/store/navbar/actions";
import LeftBlock from './LeftBlock';
import RightBlock from './RightBlock';
import TimelineNavbar from "@/components/general/TimelineNavbar";
import GuestBlock from "./components/GuestBlock";
import {SET_NAVBAR_DARK_MENU, SET_NAVBAR_LOGO_URL, SET_NAVBAR_MANU_COLOR, SET_NAVBAR_WINDOW_WIDTH} from "@/store/navbar/mutations";
import MobileNavbar from "@/components/navbar/components/MobileNavbar.vue";
import mixinNavbar from "@/mixins/navbar/mixin";

export default {
    name: 'Navbar',
    computed: {
        ...mapState({
            menuColor: state => state.navbar.menuColor,
            isFetch: state => state.navbar.isFetch,
            darkMenu: state => state.navbar.darkMenu,
            isGuest: state => state.navbar.isGuest,
        }),
    },
    watch: {
        menuColor: {
            handler(v) {
                this.$store.commit(SET_NAVBAR_DARK_MENU, v);
            },
            immediate: true
        }
    },
    components: {
        MobileNavbar,
        GuestBlock,
        TimelineNavbar,
        LeftBlock,
        RightBlock
    },
    methods: {
        handlerChangeMenuColor(e) {
            this.$store.commit(SET_NAVBAR_MANU_COLOR, e.detail.color);
        },
        handlerChangeLogoUrl(e) {
            this.$store.commit(SET_NAVBAR_LOGO_URL, e.detail.url);
        },
        onResize(e) {
            this.$store.commit(SET_NAVBAR_WINDOW_WIDTH, e.target.innerWidth);
        }
    },
    mounted() {
        this.$store.dispatch(FETCH_NAVBAR);
        this.navbar = GetAccountProperty(
            this.accountName,
            'navbar',
            GetAccountDefaults().navbar
        );

        window.addEventListener('click', e => { EventBus.emit(MAIN_WINDOW_CLICK, e); }, false);
        window.addEventListener('change-menu-color', e => { EventBus.emit(THEME_CHANGE_MENU_COLOR, e); }, false);
        window.addEventListener('change-logo-url', e => { EventBus.emit(THEME_CHANGE_LOGO_URL, e); }, false);
        window.addEventListener('resize', e => { EventBus.emit(MAIN_WINDOW_RESIZE, e); }, false);

        EventBus.on(THEME_CHANGE_MENU_COLOR, this.handlerChangeMenuColor);
        EventBus.on(THEME_CHANGE_LOGO_URL, this.handlerChangeLogoUrl);
        EventBus.on(MAIN_WINDOW_RESIZE, this.onResize);

        EventBus.emit(NAVBAR_MOUNTED);
        window.dispatchEvent(new CustomEvent(NAVBAR_MOUNTED));
    },
    beforeDestroy() {
        EventBus.off(THEME_CHANGE_MENU_COLOR, this.handlerChangeMenuColor);
        EventBus.off(THEME_CHANGE_LOGO_URL, this.handlerChangeLogoUrl);
        EventBus.off(MAIN_WINDOW_RESIZE, this.onResize);
    },
    data() {
        return {
            navbar: {}
        };
    },
    mixins: [mixinNavbar]
}
</script>
